module.exports = __webpack_public_path__ + "school/img/keyan.f8275dd3.jpg";